<template>
  <div class="table-project">
    <div class="table-project__title">
      Проектов в текущем периоде
      <span>{{ tableInfo.itemsTotal }}</span>
    </div>
    <div class="table-container-base table-container-base--modified">
      <table>
        <thead>
          <tr>
            <th class="column-ps-status">Статус</th>
            <th class="column-ps-name">Название</th>
            <th class="column-ps-country">Страна</th>

            <th class="column-ps-start">Плановый год начала реализации инвестиционной стадии проекта</th>
            <th class="column-ps-end">Плановый год окончания реализации инвестиционной стадии проекта</th>
          </tr>
        </thead>
        <tbody v-if="tableInfo.items.length">
          <tr v-for="item in tableInfo.items" :key="item.id" @click="goToPage(item.id)" class="hover-tr">
            <td>
              <span :class="getClassStatus(item.statusId)">{{ item.status.name }}</span>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.countryNames }}</td>

            <td>
              {{ item.fromEhd ? $momentFormat(item.startMonthYear, 'MMMM YYYY') : item.plannedYearStartInvStage }}
            </td>
            <td>{{ item.fromEhd ? $momentFormat(item.endMonthYear, 'MMMM YYYY') : item.plannedYearEndInvStage }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="5">Данных нет</td>
          </tr>
        </tbody>
      </table>
    </div>
    <template v-if="tableInfo.items.pagesTotal > 1">
      <PaginationRedesigned
        :pageCount="tableInfo.pagesTotal"
        :currentPage="tableInfo.pageNumber"
        @change="onPageChange($event, false)"
        @more="onPageMore($event, true)"
      />
    </template>
  </div>
</template>

<script>
  import PaginationRedesigned from '@/common/components/redesigned/PaginationRedesigned.vue';

  export default {
    name: 'TableProject',
    components: {
      PaginationRedesigned,
    },
    props: {
      tableInfo: {
        type: Object,
        default: () => {
          return {
            pageNumber: 1,
            pageSize: 10,
            items: [],
            itemsTotal: 0,
            pagesTotal: 1,
          };
        },
      },
    },
    methods: {
      getClassStatus(id) {
        switch (id) {
          case 1:
            return 'green-dark';
          case 2:
            return 'green';
          case 3:
            return 'blue';
          default:
            return 'red';
        }
      },

      goToPage(id) {
        this.$router.push({ name: 'ProjectCard', params: { id } });
      },

      onPageChange(pageNumber) {
        this.$emit('onPageChange', pageNumber);
      },

      onPageMore(pageNumber) {
        this.$emit('onPageMore', pageNumber);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/theme/default/table/table-base.scss';
  .table-project {
    margin-top: 24px;

    &__title {
      margin-bottom: 24px;
      font: $fira-16-M;
      color: $base;

      span {
        margin-left: 8px;
        font: $fira-16-M;
        background: -webkit-linear-gradient(90deg, #0078c8 0%, $green 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
</style>
